import { Component, OnInit } from '@angular/core';
import { UsersService } from '@services/users.service';
import { WebErrorService } from '@services/webError.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-collection-users',
  templateUrl: './add-collection-users.component.html',
  styleUrls: ['./add-collection-users.component.scss']
})
export class AddCollectionUsersComponent implements OnInit {
  usersData: any;
  noDataFound: any;
  sort: any;
  paginator: any;
  displayedColumns: string[] = ['checkbox', 'firstName', 'lastName', 'emailId', 'status', 'updated'];
  userStatus: any;
  totalRecords: any;
  searchText: any;
  page = 1;
  itemName = '';
  firstName = '';
  lastName = '';
  emailId = '';
  testName = '';
  itemDescription = '';
  testDescription = '';
  tagdescription = '';
  itemStatus = '';
  testStatus = '';
  isItemDescended = true;
  itemId = 10;
  userServiceSubscription$: Subscription | undefined;
  userFilterServiceSubscription$: Subscription | undefined;

  itemIds: any = [];
  itemJsonData: any = [];
  globalcollectionid: any;
  constructor(private usersService: UsersService, private webErrorService: WebErrorService) { }

  ngOnInit(): void {
    this.globalcollectionid = JSON.parse(
      sessionStorage.getItem('defaultcollectionid')
    );
    this.userServiceSubscription$ = this.usersService.getusers()?.subscribe(resData => {
      this.usersData = resData?.items;
    }, (error: any) => { this.webErrorService.handleAPIErrors(error); });
  }

  navigateToUserDetails(id): void {
  }
  toggleCheckbox(event: any): void {
    if (this.itemIds.some((e: any) => e === event.source.id)) {
      this.itemIds = this.itemIds.filter((item: any) => item !== event.source.id);
    } else {
      this.itemIds.push(event.source.id);
    }
  }


  saveItemsToTest() {
    this.itemJsonData = [];
    this.itemIds.forEach((element: any) => {
      this.itemJsonData.push({
        active: true,
        collectionId: this.globalcollectionid,
        userAccessLevelId: 0,
        useruuid: JSON.parse(element),
      });
    });
    if (this.itemJsonData.length > 0) {
      let addUserserJsonData = JSON.stringify(this.itemJsonData);
    }
  }
}
